"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 * Obtiene el assignationId que este activo de la categoría que desees (por default es GUARDIA_RANDOM) en caso de no poseer ninguno devuelve undefined
 * @param firestore
 * @param uid uid del paciente
 * @param options
 * @param category podes escoger la categoría que quieras de las attCategories
 */
function useAssignedAssignationId(firestore, uid, options, category) {
    const attCategory = category || "GUARDIA_RANDOM";
    const medicalRecordQuery = (0, firestore_2.query)((0, firestore_2.collection)(firestore, `/user/${uid}/medical_records`), (0, firestore_2.where)("att_category", "==", attCategory), (0, firestore_2.orderBy)("timestamps.dt_create", "desc"), (0, firestore_2.limit)(1));
    const assignationId = (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.Guardia({
        name: "AssignedAssignationId",
        path: `user/${uid}/medical_records`
    }, [uid]), medicalRecordQuery, options, {
        select: (medicalRecordCollection) => {
            let selectAssignationId = undefined;
            medicalRecordCollection.forEach((medicalRecord) => {
                selectAssignationId = medicalRecord.id;
            });
            /* Sólo porque ya es undefined por defecto y estoy seguro que el forEach se ejecuta me permito desactivar el non-null-assertion*/
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return selectAssignationId;
        }
    });
    return assignationId;
}
exports.default = useAssignedAssignationId;
